import styled from "styled-components";
import { breakpoints } from "root/libs/ui-styleguide/src";
import { DhlButton } from "@dhl-official/react-library";
import Headline from "../../Texts/Headline";

export const Content = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  flex-direction: column;

  @media screen and (min-width: ${breakpoints.tablet}) {
    flex-direction: row;
  }

  @media screen and (-ms-high-contrast: none) {
    max-width: 480px;
  }
`;

export const StyledHeadline = styled(Headline)`
  margin-bottom: var(--dui-size-space-5x);

  span {
    display: block;
    font-weight: 200;
  }
`;

export const ButtonsContainer = styled.div`
  margin-top: var(--gaq-size-space-25px);

  button {
    margin-bottom: var(--dui-size-space-5x);
  }
`;

export const StyledButton = styled(DhlButton)`
  max-width: 113px;
  min-width: 113px;

  &:first-child {
    margin-right: var(--dui-size-space-5x);
  }
`;

export const StyledWarningIconWrapper = styled.div`
  display: flex;
  width: 100%;
  margin-right: var(--gaq-size-space-30px);
  margin-bottom: var(--dui-size-space-10x);

  @media screen and (min-width: ${breakpoints.tablet}) {
    width: auto;
    margin-bottom: 0;
  }

  @media screen and (-ms-high-contrast: none) {
    display: block;
  }
`;

export const StyledContentWrapper = styled.div`
  @media screen and (min-width: ${breakpoints.tablet}) {
    padding-right: var(--gaq-size-space-70px);
  }
`;

export const StyledTextWrapper = styled.div`
  padding-top: var(--dui-size-space-5x);
  padding-bottom: var(--gaq-size-space-15px);

  @media screen and (min-width: ${breakpoints.tablet}) {
    padding-top: var(--gaq-size-space-15px);
    padding-bottom: var(--gaq-size-space-15px);
  }

  @media screen and (min-width: ${breakpoints.desktop}) {
    padding-top: var(--dui-size-space-5x);
    padding-bottom: var(--gaq-size-space-5px);
  }
`;
